import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {PreviousLevelsPageComponent} from './previous-levels-page.component';
import {SharedModule} from '../../shared/shared.module';
import {IndustryContentCarouselModule} from '../../home/industry-content-carousel/industry-content-carousel.module';
import { PreviousLevelsPageService } from './previous-levels-page.service';

@NgModule({
  imports: [CommonModule, SharedModule, IndustryContentCarouselModule],
  declarations: [
    PreviousLevelsPageComponent,
  ],
  exports: [PreviousLevelsPageComponent],
  providers: [PreviousLevelsPageService],
})
export class PreviousLevelsModule { }



// WEBPACK FOOTER //
// ./ts/app/industry-content/previous-levels-page/previous-levels.module.ts